<script setup lang="ts">
import SettingDisableHelp from '@/components/Sections/Settings/SettingBlocks/SettingDisableHelp.vue'
import SettingTerraformingDefault from '@/components/Sections/Settings/SettingBlocks/SettingTerraformingDefault.vue'
import SettingRingworldConstructionDefault from '@/components/Sections/Settings/SettingBlocks/SettingRingworldConstructionDefault.vue'
import SettingLanguage from '@/components/Sections/Settings/SettingBlocks/SettingLanguage.vue'

// Define a multi-word component name
defineOptions({
  name: 'SettingsMain'
})
</script>

<template>
  <div class="px-2 pt-1 max-w-4xl mx-auto">
    <SettingLanguage/>
    <SettingDisableHelp/>
    <SettingTerraformingDefault/>
    <SettingRingworldConstructionDefault/>
  </div>
</template>

<style scoped>
/* Custom styling if needed */
</style>